// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"416":"9b1465b5","538":"7da012f4","545":"4693944c","566":"c38898fa","614":"ff0a09f3","676":"8dfe0138","882":"dab3fcf6"}[chunkId] + ".chunk.js";
};